<script setup lang="ts">
import { type Component } from 'vue'

withDefaults(
  defineProps<{
    icon?: string | Component
    disabled?: boolean
  }>(),
  {
    icon: undefined,
  },
)

defineEmits<{
  (e: 'click'): void
}>()
</script>

<template>
  <button v-bind="$attrs" class="link-button" :disabled="disabled" @click="$emit('click')">
    <component v-if="icon" :is="icon" />
    <span class="text"><slot></slot></span>
  </button>
</template>

<style scoped>
.link-button {
  background: transparent;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 0;
  outline: none;
}

.text {
  color: var(--ullib-color-link);
}

.link-button:active {
  .text {
    text-decoration: underline;
  }
}
</style>
